import * as React from 'react'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import {
  Box,
  Grid,
  Typography,
} from '@mui/material'

const Notes = (props) => {
    const notes = useSelector(state => state.data.notes);
    if (!notes) {
        return <div></div>;
    }
    return (
      <Grid>
      {notes.map(({ name, uuid, date, type }) => {
        return (
          <Link to={`/${uuid}`} key={uuid} style={{ textDecoration: 'none', color: 'inherit' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', padding: '4px' }}>
            <Typography sx={{ fontSize: '9px', color: 'grey', flexShrink: 0, marginRight: '8px' }}>{date}</Typography>
            <Typography sx={{ fontSize: '14px' }}>{name}</Typography>
            {type === 'presentation' && (
              <Typography sx={{ fontSize: '8px', color: '#FF746C', marginLeft: '2px' }}>
                [Paper Learning]
              </Typography>
            )}
            </Box>
          </Link>
        );
      })}
      </Grid>
    )
}

export default Notes
